if (!customElements.get('running-club-slider')) {
  class SlideshowSwiper extends HTMLElement {
    /**
     * Section settings
     * 
     * @type {{loop: Boolean, autoplay_speed: Number, pause_on_hover: Boolean, show_navigation: Boolean, use_transparent_header: Boolean}}
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    /**
     * 使用透明导航栏
     */
    useTransparentHeader;

    constructor() {
      super();
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
      this.tabListContainer = this.querySelector('.running-club-slider__tab-list');
      this.tabItems = this.querySelectorAll('.running-club-slider__tab-list li');
    }

    connectedCallback() {
      this.mySwiper = new Swiper(`#${this.id} .swiper-container`, {
        effect: 'fade',
        speed: 500,
        loop: this.sectionSettings.loop,
        autoplay: this.sectionSettings.autoplay_speed == 0 ? false : {
          delay: this.sectionSettings.autoplay_speed * 1000,
          pauseOnMouseEnter: this.sectionSettings.pause_on_hover,
        },
        autoHeight: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: `#${this.id} .swiper-btn-next`,
          prevEl: `#${this.id} .swiper-btn-prev`,
        },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        },
        on: {
          slideChange: this.handleSlideChange.bind(this)
        },
      });
      if (this.sectionSettings.pause_on_hover && this.sectionSettings.autoplay_speed > 0) {
        this.mySwiper.el.onmouseenter = () => {
          this.mySwiper.autoplay.stop();
        };
        this.mySwiper.el.onmouseleave = () => {
          this.mySwiper.autoplay.start();
        };
      }
      for (const tab of this.tabItems) {
        tab.addEventListener('click', () => {
          const index = Number(tab.getAttribute('data-index'));
          this.sectionSettings.loop ? this.mySwiper.slideToLoop(index) : this.mySwiper.slideTo(index);
        });
      }

      this.handleSlideChange();
    }

    handleSlideChange() {
      if (!this.mySwiper) return;
      const slide = this.mySwiper.slides[this.mySwiper.activeIndex];
      const index = this.sectionSettings.loop ? this.mySwiper.realIndex : this.mySwiper.activeIndex;
      this.querySelector('.running-club-slider__tab-list li.active')?.classList.remove('active');
      const tabElement = this.querySelector(`.running-club-slider__tab-list li[data-index="${index}"]`);
      if (tabElement) {
        // Active tab.
        tabElement?.classList.add('active');
        // Scroll to tab
        const container = this.tabListContainer;
        const containerLeft = container.scrollLeft;
        const containerWidth = container.clientWidth;
        const itemLeft = tabElement.offsetLeft;
        const itemWidth = tabElement.offsetWidth;
        if (itemLeft < containerLeft || itemLeft + itemWidth > containerLeft + containerWidth) {
          container.scroll({
            left: itemLeft,
            behavior: 'smooth'
          });
        }
      }
    }

    /**
     * 更新模块高度
     */
    updateHeight() {
      if (!this.mySwiper) return;
      const slide = this.mySwiper.slides[this.mySwiper.activeIndex];
      this.style.height = slide.clientHeight - 1 + "px";
    }
  }

  customElements.define('running-club-slider', SlideshowSwiper);
}